<script setup lang="ts">
import MainBreadcrumbs from "@/ui/components/header/MainBreadcrumbs.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useRuleEnginedStore } from "@/modules/rule_engine/store";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const tabs = [
	{
		id: "steering-rules",
		titleKey: "pqa.steeringRules.title",
		to: "/pqa/steering-rules",
		icon: "fa-steering-wheel",
	},
	{
		id: "rules",
		titleKey: "pqa.rules.title",
		to: "/pqa/rules",
		icon: "fa-list-check",
	},
];

const route = useRoute();

const activeTab = computed(
	() => tabs.find((tab) => route.path.startsWith(tab.to)) ?? tabs[0]
);

const breadcrumbs = computed(() => {
	const isBuilder = route.name === "pqa.rules.builder";

	const trail = [
		{ title: t("pqa.title"), disabled: false, to: "/pqa" },
		{
			title: t(activeTab.value.titleKey),
			disabled: !isBuilder,
			to: activeTab.value.to,
		},
	];

	if (isBuilder) {
		trail.push({
			title:
				useRuleEnginedStore().activeRuleModelVersion?.name ??
				t("pqa.rules.builder.unnamedVersion"),
			disabled: true,
			to: "",
		});
	}

	return trail;
});
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" />

	<v-tabs class="mb-4">
		<v-tab
			v-for="tab in tabs"
			:key="tab.id"
			:to="tab.to"
			:prepend-icon="`fa fa-duotone ${tab.icon}`"
		>
			{{ t(tab.titleKey) }}
		</v-tab>
	</v-tabs>
	<router-view />
</template>

<style scoped lang="scss"></style>
